<!-- //
商城-订单-列表
@auth xuyd
@date 2024-10-01
//-->
<template>
  <page-layout layout="C">
    <!-- 检索区域 -->
    <div class="layout-search" style="display: flex; flex-direction: row; justify-content: space-between">
      <el-form @submit.native.prevent ref="refQueryForm" :model="queryParams" size="small" :inline="true"
               label-width="100px">
        <el-form-item prop="search">
          <el-input
              v-model="queryParams.search"
              placeholder="请输入检索内容（文件名）"
              style="width: 320px;text-align: right;"
              maxlength="20"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
          <el-button type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display:flex; justify-content: right;">
        <el-button type="primary" size="small" @click="handleAdd" icon="el-icon-plus">添加</el-button>
      </div>
    </div>

    <div class="layout-result" style="height: calc(100% - 63px);">
      <DynamicTable :query-params="queryParams"
                    :selection="true"
                    :data="tableData"
                    :metas="tableMetas"
                    @reload="getList">
        <div slot-scope="{row, item}">
          <el-button size="small" type="text" @click="handleView(row)">查看</el-button>
        </div>
      </DynamicTable>
    </div>
  </page-layout>
</template>

<script>
import OrderApi from '@/api/mall/order.api.js';

export default {
  name: 'ViewMallOrderMgmtOrderList',
  components: {},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
  ],
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: null,
        isAsc: null,
        search: null,
      },
      tableData: {
        tableLoading: false,
        records: [],
        total: 0,
      },
      tableMetas: [
        {prop: 'fileName', label: "文件名", minWidth: 120, sortable: true},
        {prop: 'fileUrl', label: "缩略图", width: 100, dataType: 'custom', customComp: "ImageView"},
        {prop: 'extName', label: "文件类型", width: 100},
        {prop: 'size', label: "文件大小", width: 120, sortable: true},
        {prop: 'bucketName', label: "所属服务", width: 120, sortable: true},
        {prop: 'fileKey', label: "文件key", minWidth: 180},
        {prop: '', label: "操作", width: 80, fixed: 'right'},
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      OrderApi.searchOrderList(this.queryParams).then(resp => {
        this.tableData.records = resp.data.records.map(item => {
          item.loading = false;
          return item;
        });
        this.tableData.total = resp.data.total;
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm("refQueryForm");
      this.$refs.refQueryForm.resetFields();
      this.queryParams.orderByColumn = null;
      this.queryParams.isAsc = null;
      this.handleQuery();
    },

    /** 排序触发事件 */
    handleSortChange(column) {
      // console.log("----handleSortChange---->", JSON.stringify(column));
      if (column.order === 'ascending') {
        this.queryParams.isAsc = true;
        this.queryParams.orderByColumn = column.prop;
      } else if (column.order === 'descending') {
        this.queryParams.isAsc = false;
        this.queryParams.orderByColumn = column.prop;
      } else {
        this.queryParams.isAsc = null;
        this.queryParams.orderByColumn = null;
      }
      this.getList();
    },
    handleAdd() {

    },

    handleView(row) {
    },
  }
}
</script>
